/**
 * Created by tschrader on 05.01.2017.
 */
export class StageScaleMode {
    public static SHOW_ALL: string = "showAll";
    public static EXACT_FIT: string = "exactFit";
    public static NO_BORDER: string = "noBorder";
    public static NO_SCALE: string = "noScale";
}